import { fetchRequestWithTypes } from './index.js';

export const POST_TRUSTED_CONTACT_REQUEST = 'POST_TRUSTED_CONTACT_REQUEST';
export const POST_TRUSTED_CONTACT_SUCCESS = 'POST_TRUSTED_CONTACT_SUCCESS';
export const POST_TRUSTED_CONTACT_ERRORED = 'POST_TRUSTED_CONTACT_ERRORED';

export const postTrustedContact = (body) =>
	fetchRequestWithTypes({
		types: [
			POST_TRUSTED_CONTACT_REQUEST,
			POST_TRUSTED_CONTACT_SUCCESS,
			POST_TRUSTED_CONTACT_ERRORED,
		],
		request: {
			method: 'POST',
			path: '/api/v1/users/:uuid/trusted_contacts',
			body,
		},
	});
